
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/oplata",
      function () {
        return require("private-next-pages/oplata.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/oplata"])
      });
    }
  